<template>
  <div>
    <div :id="id" :style="{ height: height - 32 + 'px' }" />
    <NoDataOverlay :model-value="!(value && value.length)" />
  </div>
</template>
  
<script>
import * as echarts from "echarts";
import themeJson from "@/assets/echarts-themes/oceanic-balanced.json";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import NoDataOverlay from "@/components/atoms/analytics/NoDataOverlay.vue";

export default {
  name: "CampaignLocaleDistribution",
  components: {
    NoDataOverlay,
  },
  props: {
    id: {
      type: String,
      default: `campaign-browser-distribution-${uuidv4()}`,
    },
    value: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      chartInstance: null,
      resizeObserver: null,
    };
  },
  watch: {
    value: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
    this.observeResize();
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },

  methods: {
    getDailyLabelsFromPast7Days() {
      const start = moment().subtract(6, "days").startOf("day");
      const labels = [];

      for (let i = 0; i < 7; i++) {
        const date = start.clone().add(i, "days");
        labels.push(date.format("MMMM D"));
      }

      return labels;
    },
    renderChart() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      const chart = echarts.init(chartDom, themeJson.themeName);
      chart.setOption(this.getOptions());

      this.chartInstance = chart;
    },
    observeResize() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          this.chartInstance?.resize();
        });
      });

      this.resizeObserver.observe(chartDom);
    },
    getOptions() {
      return {
        title: {
          text: "Locales",
          left: "center",
        },
        tooltip: {
          confine: true,
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        legend: {
          orient: "horizontal",
          bottom: 0,
        },
        series: [
          {
            name: "Locales",
            type: "pie",
            top: "10%",
            bottom: "10%",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 8,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: true,
              position: "outside",
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 10,
            },
            data: this.value.map((item) => ({
              name: item.locale,
              value: item.count,
            })),
          },
        ],
      };
    },
  },
};
</script>
  
  <style scoped>
.inventory-item-pie-chart {
  width: 100%;
  font-family: Roboto, sans-serif;
}
</style>
  